import React, { useContext, useEffect } from 'react';
import { useHistory } from 'react-router';
import { useParams } from 'react-router-dom';
import { hostContext } from '../../context/hostContext';

import apiUsuarios from '../../services/apis/apiUsuarios';
import Eventos from './Eventos';
import Formulario from './Formulario';

import style from '../../assets/styles/perfil-descargar.module.css';

const DescargarScreen = () => {

    const history = useHistory();
    const { id } = useParams(); // Este es el id del organizador

    const { selectedOrganizador, setSelectedOrganizador } = useContext( hostContext )
    
    useEffect(() => {
        
        const fetchData = async() => {
            
            const buscarOrganizador = await apiUsuarios.getSingle( id );
            if( !buscarOrganizador.ok ) { return history.push('/organizador') }

            setSelectedOrganizador( buscarOrganizador.response.data );
        }

        fetchData();
        
    }, [ id, setSelectedOrganizador, history ])

    return (selectedOrganizador ? 
    <div className={ style.descargarScreen }>

        <div className={ style.contenedor } >
            <div className={ style.banner }>
                <img src={ selectedOrganizador.imgBanner } alt="imagen-de-cabecera" className={ style.banner } />
            </div>


            <div className={ style.contenido } >
                <h1> { selectedOrganizador.nombre } </h1>
                <p> 
                    ¿Asististe a algún evento con nosotros? 
                    Ingresa el correo con el que te registraste para descargar tu constancia de asistencia 
                </p>

                <Formulario />

                <Eventos />
            </div>
        </div>

        
        
            
    </div>

    :  
        <div className="cargando">
            <div className="row text-center align-items-center vh-100">
                <div className="col">
                    <p>Cargando contenido espera un momento...</p>
                </div>
            </div>
        </div>
    )
}

export default DescargarScreen
